module.exports = __webpack_public_path__ + "img/logo.a25cf052.png";